import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '@heroui/react';
import { TriangleIcon } from '../../assets/icons';
import AttachementMessage from './AttachementMessage';
import { COLORS } from '../../constants/colors';

const ChatAreaBody = ({
    message,
    name,
    avatar,
    isSeenMessage,
    messageTime,
    senderId,
    chatType,
    onHover,
    file,
    fileType,
    attachements,
    completeItem,
    isHtmlMessage = false
}) => {
    const attachementType = fileType?.startsWith('image/') ? 'image' : fileType?.startsWith('video/') ? 'video' : 'document';
    const currentUserId = useSelector((state) => state?.user?.user?.id);
    const me = Number(currentUserId) === Number(senderId);
    const navigate = useNavigate();

    return (
        <div className={`w-full flex mt-2 space-x-3 max-w-xs ${me ? 'ml-auto justify-end' : ''}`}
            onMouseEnter={onHover}>
            {file ?
                <AttachementMessage
                    message={message}
                    name={name}
                    avatar={avatar}
                    isSeenMessage={isSeenMessage}
                    messageTime={messageTime}
                    me={me}
                    chatType={chatType}
                    onHover={onHover}
                    fileType={attachementType}
                    attachements={attachements}
                    completeItem={completeItem}
                />
                :
                <div>
                    {/* Message Container */}
                    {!me && chatType === 'group' &&
                        <button
                            type="button"
                            className='w-6 !-mt-2 rounded-full'
                            onClick={() => navigate(`/partners/partner-detail/${senderId}`)}
                            aria-label={`View ${name || 'sender'} profile`}
                        >
                            <Avatar src={avatar}
                                name={name?.slice(0, 1)?.toLocaleUpperCase() + name?.split(' ')?.[1]?.slice(0, 1)?.toLocaleUpperCase()}
                                className="w-6 h-6 cursor-pointer text-xs bg-opacity-65 bg-surface0"
                                classNames={{
                                    base: "bg-mediumgrey/30",
                                    icon: "text-black/60",
                                }}
                            />
                        </button>
                    }
                    <div className={`relative h-full p-2 rounded-lg ${me ? 'bg-chat-user' : `bg-chat-assistant -top-3 left-2.5 ${chatType === 'group' && 'ml-6'}`}`}>
                        {/* Message */}
                        {isHtmlMessage ? (
                            <p
                                className={`float-left h-full text-sm min-w-20 pr-8 whitespace-pre-wrap ${me ? 'text-white pb-4' : `text-chat-muted ${chatType !== 'group' && 'pb-4'}`} mb-1 `}
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(message || "", {
                                        ADD_ATTR: ["target", "rel", "class"],
                                    }),
                                }}
                            />
                        ) : (
                            <p className={`float-left h-full text-sm min-w-20 pr-8 whitespace-pre-wrap ${me ? 'text-white pb-4' : `text-chat-muted ${chatType !== 'group' && 'pb-4'}`} mb-1 `}>
                                {message}
                            </p>
                        )}
                        {/* Message Date*/}
                        <span className={`absolute right-1.5 bottom-1 text-xs ${me ? 'text-white' : 'text-chat-muted'} leading-none`}>
                            {messageTime ? messageTime : ''}
                        </span>
                        {/* Triangle */}
                        {!me ? (
                            <span>
                                <TriangleIcon
                                    className={
                                        'rotate-[60deg] absolute top-[-5px] -left-1.5'
                                    }
                                    color={COLORS.chatAssistant}
                                />
                            </span>
                        ) : <span>
                            <TriangleIcon
                                className={
                                    '-rotate-[60deg] absolute -top-[5px] -right-1.5'
                                }
                                color={COLORS.chatUser}
                            />
                        </span>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default ChatAreaBody
